<template>
  <div class="input">
    <input
      :id="inputId"
      v-regexp="/^[\d\s]+$/"
      type="tel"
      data-private
      :title="inputTitle"
      :value="value"
      :class="{'invalid': !isValid}"
      :size="inputSize"
      placeholder="0000 0000 0000 0000"
      autocomplete="cc-number"
      @focus="checkReset"
      @input="handleInput($event)"
      @blur="checkLength"
    />

    <label :for="inputId">
      <span>{{ inputName }}</span>
    </label>
  </div>
</template>

<script>
import creditCardType from 'lib/utils/creditCardType';

import { luhn, prettyCardNumber } from '@/services/mixins';

const maxCardNumberLength = 20;

const AVAILABLE_PAYMENTS_SYSTEMS = [
  'mir',
  'visa',
  'mastercard',
  'maestro',
  'uzcard',
  'humo',
];

export default {
  mixins: [luhn, prettyCardNumber],
  props: {
    value: [Number, String],
    inputName: String,
    inputTitle: String,
    inputId: String,
    inputSize: { type: String, default: '12' },
  },
  data() {
    return {
      creditCardType: {},
      acceptedTypes: AVAILABLE_PAYMENTS_SYSTEMS,
      valueFormatted: this.value,
      isValid: true,
    };
  },
  computed: {
    isCardTypeDetected() {
      // поиск доступной платежной сисемы по номеру карты
      const paymentSystem = creditCardType(this.valueFormatted).find(card => AVAILABLE_PAYMENTS_SYSTEMS.includes(card.type));

      // если платежная система не найдена
      if (this.$validate.isUndefined(paymentSystem)) {
        return false;
      }

      // если такой тип карты отсутствует
      // TODO: @danealton по сути это не нужно, но тогда ломается isFilled
      if (this.$validate.isEmptyObject(this.creditCardType)) {
        return false;
      }

      return true;
    },
    maxValue() {
      // максимально допустимое количество символов для введенных данных
      return this.isCardTypeDetected ? this.creditCardType.lengths[this.creditCardType.lengths.length - 1] : maxCardNumberLength;
    },
    isLuhn() {
      // проверяет контрольное (последнее) число в введенном номере карты
      return this.luhn(this.valueFormatted);
    },
    isFilled() {
      // совпадает ли введенное количество символов с необходимым для этого типа карты (тип карты определяется до этой проверки)
      return this.isCardTypeDetected && this.creditCardType.lengths.some(el => el === this.valueFormatted.length);
    },
    cardIsValid() {
      // финальная проверка всех правил валидации
      return this.isCardTypeDetected && this.isFilled && this.isLuhn;
    },
  },
  methods: {
    handleInput(e) {
      // удаляем пробелы
      this.valueFormatted = e.target.value.replace(/\s/g, '');

      // Если значение больше максимального то обрезаем до максимального (удаляем последний символ)
      if (this.valueFormatted.length > this.maxValue) {
        this.valueFormatted = this.valueFormatted.slice(0, -1);
        e.target.value = e.target.value.slice(0, -1);
      }

      // введенные данные в зависимости от типа карты сравниваются с соответствующим паттерном (this.creditCardType) для дальнейшей валидации
      this.creditCardType = creditCardType(this.valueFormatted).length === 1 ? creditCardType(this.valueFormatted)[0] : {};

      // prettyCardNumber маска для форматирования введенных данных
      this.$emit('input', this.prettyCardNumber(this.valueFormatted, this.creditCardType));

      // Валидация после двух введенных символов
      if (this.valueFormatted.length > 2) {
        this.validation();
        return;
      }

      this.isValid = true;
    },
    validation() {
      if (!this.isCardTypeDetected) {
        this.isValid = false;
      } else if (this.valueFormatted.length < this.creditCardType.lengths[0]) {
        this.isValid = true;
      } else if (!this.cardIsValid) {
        this.isValid = false;
      } else {
        this.isValid = true;
        // this.valueFormatted.length >= 16 && this.$emit('focusNext');
        // temporary fix CPME-1114
        if (this.valueFormatted.length >= 16 && this.valueFormatted.length !== 17) {
          this.$emit('focusNext');
        }
      }
    },
    checkLength() {
      if (!this.isFilled) {
        this.isValid = false;
      }
    },
    checkReset() {
      this.isValid = true;
    },
    reset() {
      this.valueFormatted = '';
    },
  },
};
</script>
